const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
      api: "https://dongnaiip-api.cgis.asia/",
      domainUserSide: "http://localhost:3000",
      domainAdminSide: "http://localhost:3000",
      domainName: "dongnaiip.vietnamiz.com",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
  production: {
      api: "https://dongnaiip-api.cgis.asia/",
      domainUserSide: "https://dongnaiip.vietnamiz.com",
      domainAdminSide: "https://admin.dongnaiip.cgis.asia",
      domainName: "dongnaiip.vietnamiz.com",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
};

module.exports = apiEnvironment[env];
